export const iMemberProfile= {
  FirstName: "",
  LastName: "",
  Title: "",
  TeamName: "",
  TeamId: "999",
  Role: "",
  ExtraRole: "",
  Postno: "",
  Address: "",
  City: "",
  Phone: "",
  Email: "",
  Birthdate: "",
  Parent: "",
  ParentPhone: "",
  ParentEmail: "",
  PaymentEmail: "",
  Started: "",
  Stopped: "",
  Comment: "",
  ImageUrl: "",
  Status: "ny"
};
